import balance from "@/store/game/balance.store";
import budgets from "@/store/game/budgets/list.store";
import chapters from "@/store/game/chapters/list.store";
import curveballs from "@/store/game/curveballs/list.store";
import funds from "@/store/game/funds/list.store";
import hints from "@/store/game/hints/list.store";
import scores from "@/store/game/scores/list.store";
import tricks from "@/store/game/tricks/list.store";
import performance from "@/store/game/performance.store";
import reviews from "@/store/game/reviews.store";
import { LOCAL } from "@/store/mutations";

const { START_GAME, COMPLETE_GAME, PAUSE_GAME, UNPAUSE_GAME } = LOCAL;

export default {
	namespaced: true,
	modules: {
		balance,
		budgets,
		chapters,
		curveballs,
		funds,
		hints,
		performance,
		reviews,
		scores,
		tricks,
	},
	state: {
		active: false,
		complete: false,
		paused: false,
		outcome: '',
	},
	getters: {
		determineOutcome: (state, getters, rootState, rootGetters) => {
			let result = 'lose';
			result = rootGetters["game/funds/haveWinningBalances"] ? 'win' : result;
			result = rootGetters["game/scores/zeroScore"] ? 'lose' : result;
			return result;
		},
	},
	actions: {
		start({ commit, dispatch }) {
			commit(START_GAME);
			dispatch("chapters/activate", { index: 0 });
		},
		end({ commit, getters }) {
			commit(COMPLETE_GAME, { outcome: getters.determineOutcome });
		},
		pause({ commit }) {
			commit(PAUSE_GAME);
		},
		unpause({ commit }) {
			commit(UNPAUSE_GAME);
		},
	},
	mutations: {
		[START_GAME](state) {
			state.active = true;
		},
		[COMPLETE_GAME](state, { outcome }) {
			state.active = false;
			state.complete = true;
			state.outcome = outcome;
		},
		[PAUSE_GAME](state) {
			state.paused = true;
		},
		[UNPAUSE_GAME](state) {
			state.paused = false;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/index.js